// Only manages the new content inventory; existing forecast slots keep their lifecycle.
let intersectionObserver;
let resizeObserver;

function disconnect() {
  if (intersectionObserver) intersectionObserver.disconnect();
  if (resizeObserver) resizeObserver.disconnect();
}

function enqueue(slot) {
  if (!slot.isConnected || slot.dataset.contentAd !== 'pending' ||
      slot.hasAttribute('data-adsbygoogle-status') || slot.getBoundingClientRect().width === 0) return;
  slot.classList.add('adsbygoogle');
  slot.dataset.contentAd = 'queued';
  // Consent remains under the existing CMP/AdSense integration.
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (error) {
    slot.dataset.contentAd = 'failed';
  }
  if (intersectionObserver) intersectionObserver.unobserve(slot);
  if (resizeObserver) resizeObserver.unobserve(slot);
}

function initialize() {
  disconnect();
  if (document.documentElement.hasAttribute('data-turbolinks-preview')) return;
  const slots = document.querySelectorAll('[data-content-ad="pending"]');
  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.dataset.contentAdNear === 'true') enqueue(entry.target);
      });
    });
  }
  if ('IntersectionObserver' in window) {
    intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.dataset.contentAdNear = 'true';
          enqueue(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
  }
  slots.forEach(slot => {
    if (resizeObserver) resizeObserver.observe(slot);
    if (intersectionObserver) intersectionObserver.observe(slot);
    else {
      slot.dataset.contentAdNear = 'true';
      enqueue(slot);
    }
  });
}

function prepareCache() {
  disconnect();
  document.querySelectorAll('ins[data-content-ad]').forEach(slot => {
    // Cache fresh markup, never AdSense iframes or processed status attributes.
    const fresh = slot.cloneNode(false);
    Array.from(fresh.attributes).forEach(attribute => {
      if (!['class', 'data-ad-client', 'data-ad-slot', 'data-ad-format',
        'data-full-width-responsive'].includes(attribute.name)) fresh.removeAttribute(attribute.name);
    });
    fresh.classList.remove('adsbygoogle');
    fresh.style.display = 'block';
    fresh.dataset.contentAd = 'pending';
    slot.replaceWith(fresh);
  });
}

document.addEventListener('turbolinks:load', initialize);
document.addEventListener('turbolinks:before-cache', prepareCache);
document.addEventListener('turbolinks:before-render', disconnect);
